/**
 * Created by fers on 25.07.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';

interface ActivateChannelMutationProps {
    channel_id: string;
    organisation_id: string;
}

export default class ActivateChannelMutation extends Relay.Mutation<ActivateChannelMutationProps> {
    static propTypes = {
        channel_id: PropTypes.string.isRequired,
        organisation_id: PropTypes.string.isRequired,
    };

    getMutation() {
        return Relay.QL`mutation {activateChannel}`;
    }

    getVariables() {
        return {
            channel_id: this.props.channel_id,
            organisation_id: this.props.organisation_id,
        };
    }

    getFatQuery() {
        return Relay.QL`
          fragment on ActivateChannelPayload {
              clientMutationId,
              job {
                  id,
                  organisation_id,
                  realId,
                  name
              },
              updatedNode {
                  id,
                  realId,
                  activated,
				  organisation {
					  id,
					  channels(first: 100, deleted: false) {
						  edges {
							  node {
								  id
							  }
						  }
					  }
				  }
              }
          }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [
                this.getFatQuery()
            ],
        }];
    }
}
